const $ = require('jquery');

// The goal here is to dynamically limit the options of the "Which Service Are You Renewing" dropdown based on the page URL that the form is being loaded on. If on the Ants Renewal page, the dropdown's options should only be one of the two Ants-related ones and the others should be hidden from view/selection.


// Quick check to see if the form is loaded before proceeding
if ($('.webform-submission-renew-your-service-form').length) {

  // Quick variable for the dropdown field
  var $renewfield = $('#edit-service-renewing');

  // Retrieve current URL
  var $url = document.URL;

  // If on the Ants Renewal Page, then hide all other dropdown options.
  if($url.indexOf('ant') != -1) {
    $('#edit-service-renewing option').each(function() {
      if ( $(this).val().indexOf('Ant') === -1 ) {
        $(this).remove();
      }
    });
  }

  // If on the Wasps Renewal Page, then hide all other dropdown options.
  if($url.indexOf('wasp') != -1) {
    $('#edit-service-renewing option').each(function() {
      if ( $(this).val().indexOf('Wasp') === -1 ) {
        $(this).remove();
      }
    });
  }

  // If on the Fall Invader Renewal Page, then hide all other dropdown options.
  if($url.indexOf('fall') != -1) {
    $('#edit-service-renewing option').each(function() {
      if ( $(this).val().indexOf('Fall') === -1 ) {
        $(this).remove();
      }
    });
  }

  // If on the Mosquito & Tick Renewal Page, then hide all other dropdown options.
  if($url.indexOf('tick') != -1) {
    $('#edit-service-renewing option').each(function() {
      if ( $(this).val().indexOf('Tick') === -1 ) {
        $(this).remove();
      }
    });
  }

}
